// Auto-generated technical specifications dataset.
// Each entry maps a product to its tech-spec PDF.

export const techSpecs = [
  {
    "id": "techspec-2-n-1-customs",
    "title": "2-N-1 Custom Logo Mat - Technical Specifications",
    "shortTitle": "2-N-1 Custom Logo Mat",
    "category": "Custom Logo Mats",
    "industries": [
      "Commercial",
      "Retail"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_2N1_CLM.pdf"
  },
  {
    "id": "techspec-2-n-1",
    "title": "2-N-1 Grid Matting - Technical Specifications",
    "shortTitle": "2-N-1 Grid Matting",
    "category": "Grid Matting",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_2n1.pdf"
  },
  {
    "id": "techspec-2420",
    "title": "2420 Adhesive - Technical Specifications",
    "shortTitle": "2420 Adhesive",
    "category": "Accessories",
    "industries": [
      "All Industries"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_ATS_2420.pdf"
  },
  {
    "id": "techspec-440-gldstk",
    "title": "440-GLDSTK Glue Stick - Technical Specifications",
    "shortTitle": "440-GLDSTK Glue Stick",
    "category": "Accessories",
    "industries": [
      "All Industries"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_ATS_440-GLDSTK.pdf"
  },
  {
    "id": "techspec-631-1100",
    "title": "631-1100 Adhesive - Technical Specifications",
    "shortTitle": "631-1100 Adhesive",
    "category": "Accessories",
    "industries": [
      "All Industries"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_ATS_631-1100.pdf"
  },
  {
    "id": "techspec-astoria-nop---customs",
    "title": "Astoria Nop Custom Logo Mat - Technical Specifications",
    "shortTitle": "Astoria Nop Custom Logo Mat",
    "category": "Custom Logo Mats",
    "industries": [
      "Hospitality",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_AstoriaNop_CLM.pdf"
  },
  {
    "id": "techspec-astoria-nop---rg",
    "title": "Astoria Nop Roll Goods - Technical Specifications",
    "shortTitle": "Astoria Nop Roll Goods",
    "category": "Broadloom",
    "industries": [
      "Hospitality",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_AstoriaNop_RG.pdf"
  },
  {
    "id": "techspec-atlas-plus",
    "title": "Atlas Plus Carpet Tile - Technical Specifications",
    "shortTitle": "Atlas Plus Carpet Tile",
    "category": "Carpet Tile",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_AtlasPlus.pdf"
  },
  {
    "id": "techspec-avenue-rib",
    "title": "Avenue Rib Roll Goods - Technical Specifications",
    "shortTitle": "Avenue Rib Roll Goods",
    "category": "Broadloom",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_AvenueRib_RG.pdf"
  },
  {
    "id": "techspec-axis-rib",
    "title": "Axis Rib Roll Goods - Technical Specifications",
    "shortTitle": "Axis Rib Roll Goods",
    "category": "Broadloom",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_AxisRib_RG.pdf"
  },
  {
    "id": "techspec-bubble-mat",
    "title": "Bubble Mat - Technical Specifications",
    "shortTitle": "Bubble Mat",
    "category": "Anti-Fatigue",
    "industries": [
      "Retail",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_BubbleMat.pdf"
  },
  {
    "id": "techspec-champion-lp",
    "title": "Champion LP Carpet Tile - Technical Specifications",
    "shortTitle": "Champion LP Carpet Tile",
    "category": "Carpet Tile",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TSS_ChampionLP.pdf"
  },
  {
    "id": "techspec-channel-rib",
    "title": "Channel Rib Carpet Tile - Technical Specifications",
    "shortTitle": "Channel Rib Carpet Tile",
    "category": "Carpet Tile",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_ChannelRib.pdf"
  },
  {
    "id": "techspec-chevron-rib",
    "title": "Chevron Rib Commercial Mat - Technical Specifications",
    "shortTitle": "Chevron Rib Commercial Mat",
    "category": "Commercial Mats",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TSS_ChevronRib.pdf"
  },
  {
    "id": "techspec-comfort-step-42",
    "title": "Comfort Step 42 - Technical Specifications",
    "shortTitle": "Comfort Step 42",
    "category": "Anti-Fatigue",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_ComfortStep.pdf"
  },
  {
    "id": "techspec-comfort-step-diamond",
    "title": "Comfort Step Diamond - Technical Specifications",
    "shortTitle": "Comfort Step Diamond",
    "category": "Anti-Fatigue",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TSS_ComfortStepDiamond.pdf"
  },
  {
    "id": "techspec-comfort-step-esd",
    "title": "Comfort Step ESD - Technical Specifications",
    "shortTitle": "Comfort Step ESD",
    "category": "Anti-Fatigue",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_ComfortStepESD.pdf"
  },
  {
    "id": "techspec-cross-guard-tile",
    "title": "Cross Guard Tile - Technical Specifications",
    "shortTitle": "Cross Guard Tile",
    "category": "Carpet Tile",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TSS_Crossguard.pdf"
  },
  {
    "id": "techspec-diamond-plate-safety-step",
    "title": "Diamond Plate Safety Step - Technical Specifications",
    "shortTitle": "Diamond Plate Safety Step",
    "category": "Anti-Fatigue",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_DiamondPlateSafetyStep.pdf"
  },
  {
    "id": "techspec-diplomat-tile",
    "title": "Diplomat Carpet Tile - Technical Specifications",
    "shortTitle": "Diplomat Carpet Tile",
    "category": "Carpet Tile",
    "industries": [
      "Retail",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_Diplomat.pdf"
  },
  {
    "id": "techspec-dominator-tile",
    "title": "Dominator Carpet Tile - Technical Specifications",
    "shortTitle": "Dominator Carpet Tile",
    "category": "Carpet Tile",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_Dominator.pdf"
  },
  {
    "id": "techspec-dominator-lp-tile",
    "title": "Dominator LP Carpet Tile - Technical Specifications",
    "shortTitle": "Dominator LP Carpet Tile",
    "category": "Carpet Tile",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_DominatorLP.pdf"
  },
  {
    "id": "techspec-edge-j",
    "title": "Edge-J Section Trim - Technical Specifications",
    "shortTitle": "Edge-J Section Trim",
    "category": "Accessories",
    "industries": [
      "All Industries"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_ACTS_Edge-J.pdf"
  },
  {
    "id": "techspec-edge-r",
    "title": "Edge-R Section Trim - Technical Specifications",
    "shortTitle": "Edge-R Section Trim",
    "category": "Accessories",
    "industries": [
      "All Industries"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_ACTS_Edge-R.pdf"
  },
  {
    "id": "techspec-edge-rlpx",
    "title": "Edge-RLPX Section Trim - Technical Specifications",
    "shortTitle": "Edge-RLPX Section Trim",
    "category": "Accessories",
    "industries": [
      "All Industries"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_ACTS_Edge-RLPX.pdf"
  },
  {
    "id": "techspec-edge-z",
    "title": "Edge-Z Section Trim - Technical Specifications",
    "shortTitle": "Edge-Z Section Trim",
    "category": "Accessories",
    "industries": [
      "All Industries"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_ACTS_Edge-Z.pdf"
  },
  {
    "id": "techspec-elements-100-series",
    "title": "Elements 100 Series Rubber Tile - Technical Specifications",
    "shortTitle": "Elements 100 Series Rubber Tile",
    "category": "Rubber Flooring",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_100Series.pdf"
  },
  {
    "id": "techspec-elements-200-series",
    "title": "Elements 200 Series Rubber Tile - Technical Specifications",
    "shortTitle": "Elements 200 Series Rubber Tile",
    "category": "Rubber Flooring",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_200Series.pdf"
  },
  {
    "id": "techspec-elements-350-series",
    "title": "Elements 350 Series Rubber Tile - Technical Specifications",
    "shortTitle": "Elements 350 Series Rubber Tile",
    "category": "Rubber Flooring",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_350Series.pdf"
  },
  {
    "id": "techspec-elements-950-series",
    "title": "Elements 950 Series Rubber Tile - Technical Specifications",
    "shortTitle": "Elements 950 Series Rubber Tile",
    "category": "Rubber Flooring",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_950Series.pdf"
  },
  {
    "id": "techspec-elite-step",
    "title": "Elite Step Anti-Fatigue Mat - Technical Specifications",
    "shortTitle": "Elite Step Anti-Fatigue Mat",
    "category": "Anti-Fatigue",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_EliteStep.pdf"
  },
  {
    "id": "techspec-freestahyl-tile",
    "title": "Freestahyl Carpet Tile - Technical Specifications",
    "shortTitle": "Freestahyl Carpet Tile",
    "category": "Carpet Tile",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TSS_Freestahyl.pdf"
  },
  {
    "id": "techspec-frontrunner-entry",
    "title": "Frontrunner Entry System - Technical Specifications",
    "shortTitle": "Frontrunner Entry System",
    "category": "Grid Matting",
    "industries": [
      "Retail",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_Frontrunner.pdf"
  },
  {
    "id": "techspec-frontrunner-plus",
    "title": "Frontrunner Plus Entry System - Technical Specifications",
    "shortTitle": "Frontrunner Plus Entry System",
    "category": "Grid Matting",
    "industries": [
      "Retail",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_FrontrunnerPlus.pdf"
  },
  {
    "id": "techspec-frontrunner-plus-sb",
    "title": "Frontrunner Plus SB Entry System - Technical Specifications",
    "shortTitle": "Frontrunner Plus SB Entry System",
    "category": "Grid Matting",
    "industries": [
      "Retail",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_FrontrunnerPlus_SB.pdf"
  },
  {
    "id": "techspec-frontrunner-sb",
    "title": "Frontrunner SB Entry System - Technical Specifications",
    "shortTitle": "Frontrunner SB Entry System",
    "category": "Grid Matting",
    "industries": [
      "Retail",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_FrontrunnerSB.pdf"
  },
  {
    "id": "techspec-h-section",
    "title": "H-Section Trim - Technical Specifications",
    "shortTitle": "H-Section Trim",
    "category": "Accessories",
    "industries": [
      "All Industries"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_ACTS_H-Section.pdf"
  },
  {
    "id": "techspec-hercules-mxp",
    "title": "Hercules MXP Carpet Tile - Technical Specifications",
    "shortTitle": "Hercules MXP Carpet Tile",
    "category": "Carpet Tile",
    "industries": [
      "Retail",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_HerculesMXP.pdf"
  },
  {
    "id": "techspec-heron-rib",
    "title": "Heron Rib Grid Entry System - Technical Specifications",
    "shortTitle": "Heron Rib Grid Entry System",
    "category": "Grid Matting",
    "industries": [
      "Hospitality",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_HeronRib.pdf"
  },
  {
    "id": "techspec-heron-tile",
    "title": "Heron Tile Grid Entry System - Technical Specifications",
    "shortTitle": "Heron Tile Grid Entry System",
    "category": "Grid Matting",
    "industries": [
      "Hospitality",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_HeronTile.pdf"
  },
  {
    "id": "techspec-kensington-tile",
    "title": "Kensington Carpet Tile - Technical Specifications",
    "shortTitle": "Kensington Carpet Tile",
    "category": "Carpet Tile",
    "industries": [
      "Hospitality",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_Kensington.pdf"
  },
  {
    "id": "techspec-kensington-custom",
    "title": "Kensington Custom Logo Mat - Technical Specifications",
    "shortTitle": "Kensington Custom Logo Mat",
    "category": "Custom Logo Mats",
    "industries": [
      "Hospitality",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_Kensington_CLM.pdf"
  },
  {
    "id": "techspec-kensington---rg",
    "title": "Kensington Roll Goods - Technical Specifications",
    "shortTitle": "Kensington Roll Goods",
    "category": "Broadloom",
    "industries": [
      "Hospitality",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_Kensington_RG.pdf"
  },
  {
    "id": "techspec-kitchen-mat",
    "title": "Kitchen Mat - Technical Specifications",
    "shortTitle": "Kitchen Mat",
    "category": "Anti-Fatigue",
    "industries": [
      "Retail",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_KitchenMat.pdf"
  },
  {
    "id": "techspec-lock-p799-i-o-rubber",
    "title": "Lock P799 I-O Rubber Adhesive - Technical Specifications",
    "shortTitle": "Lock P799 I-O Rubber Adhesive",
    "category": "Accessories",
    "industries": [
      "All Industries"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_ATS_Lock-P799.pdf"
  },
  {
    "id": "techspec-low-profile-edge-rlp",
    "title": "Low-Profile Edge-RLP Section Trim - Technical Specifications",
    "shortTitle": "Low-Profile Edge-RLP Section Trim",
    "category": "Accessories",
    "industries": [
      "All Industries"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_ACTS_LP-Edge-RLP.pdf"
  },
  {
    "id": "techspec-low-profile-ulp-section",
    "title": "Low-Profile ULP Section Trim - Technical Specifications",
    "shortTitle": "Low-Profile ULP Section Trim",
    "category": "Accessories",
    "industries": [
      "All Industries"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_ACTS_ULP-Section.pdf"
  },
  {
    "id": "techspec-luxury-step",
    "title": "Luxury Step Anti-Fatigue Mat - Technical Specifications",
    "shortTitle": "Luxury Step Anti-Fatigue Mat",
    "category": "Anti-Fatigue",
    "industries": [
      "Retail",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_LuxuryStep.pdf"
  },
  {
    "id": "techspec-lvt-1-8-0",
    "title": "LVT 1-8-0 Adhesive - Technical Specifications",
    "shortTitle": "LVT 1-8-0 Adhesive",
    "category": "Accessories",
    "industries": [
      "All Industries"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_FTS_LVT-180.pdf"
  },
  {
    "id": "techspec-marble-step-2-0",
    "title": "Marble Step 2.0 - Technical Specifications",
    "shortTitle": "Marble Step 2.0",
    "category": "Anti-Fatigue",
    "industries": [
      "Retail",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_MarbleStep.pdf"
  },
  {
    "id": "techspec-monster-tile-series",
    "title": "Monster Tile Series - Technical Specifications",
    "shortTitle": "Monster Tile Series",
    "category": "Rubber Flooring",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_MonsterTileSeries.pdf"
  },
  {
    "id": "techspec-natural-coco-custom",
    "title": "Natural Coco Custom Logo Mat - Technical Specifications",
    "shortTitle": "Natural Coco Custom Logo Mat",
    "category": "Custom Logo Mats",
    "industries": [
      "Hospitality",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_NatCoco_CLM.pdf"
  },
  {
    "id": "techspec-natural-coco",
    "title": "Natural Coco Roll Goods - Technical Specifications",
    "shortTitle": "Natural Coco Roll Goods",
    "category": "Broadloom",
    "industries": [
      "Hospitality",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_NatCoco_RG.pdf"
  },
  {
    "id": "techspec-nature-view-rustique-18x18",
    "title": "Nature View™ Style Rustique 18in x 18in LVT - Technical Specifications",
    "shortTitle": "Nature View™ Style Rustique 18in x 18in LVT",
    "category": "Luxury Vinyl",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_NVR18x18.pdf"
  },
  {
    "id": "techspec-nature-view-rustique-18x36",
    "title": "Nature View™ Style Rustique 18in x 36in LVT - Technical Specifications",
    "shortTitle": "Nature View™ Style Rustique 18in x 36in LVT",
    "category": "Luxury Vinyl",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_NVR18x36.pdf"
  },
  {
    "id": "techspec-nature-view-rustique-6x36",
    "title": "Nature View™ Style Rustique 6in x 36in LVT - Technical Specifications",
    "shortTitle": "Nature View™ Style Rustique 6in x 36in LVT",
    "category": "Luxury Vinyl",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_NVR6x36.pdf"
  },
  {
    "id": "techspec-nature-view-rustique-7x48",
    "title": "Nature View™ Style Rustique 7in x 48in LVT - Technical Specifications",
    "shortTitle": "Nature View™ Style Rustique 7in x 48in LVT",
    "category": "Luxury Vinyl",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_NVR7x48_40MIL.pdf"
  },
  {
    "id": "techspec-overlap-ramp-81611",
    "title": "OVERLAP Ramp 81611 - Technical Specifications",
    "shortTitle": "OVERLAP Ramp 81611",
    "category": "Accessories",
    "industries": [
      "All Industries"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_FTS_RAMP-81611.pdf"
  },
  {
    "id": "techspec-pinnacle-h-d--custom",
    "title": "Pinnacle H.D. Custom Logo Mat - Technical Specifications",
    "shortTitle": "Pinnacle H.D. Custom Logo Mat",
    "category": "Custom Logo Mats",
    "industries": [
      "Retail",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TSS_Pinnacle-HD.pdf"
  },
  {
    "id": "techspec-portico-nop-tile",
    "title": "Portico Nop Carpet Tile - Technical Specifications",
    "shortTitle": "Portico Nop Carpet Tile",
    "category": "Carpet Tile",
    "industries": [
      "Hospitality",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_PorticoNop.pdf"
  },
  {
    "id": "techspec-portico-nop---customs",
    "title": "Portico Nop Custom Logo Mat - Technical Specifications",
    "shortTitle": "Portico Nop Custom Logo Mat",
    "category": "Custom Logo Mats",
    "industries": [
      "Hospitality",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_PorticoNop_CLM.pdf"
  },
  {
    "id": "techspec-portico-nop---rg",
    "title": "Portico Nop Roll Goods - Technical Specifications",
    "shortTitle": "Portico Nop Roll Goods",
    "category": "Broadloom",
    "industries": [
      "Hospitality",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_PorticoNop_RG.pdf"
  },
  {
    "id": "techspec-premier-nop-tile",
    "title": "Premier Nop Carpet Tile - Technical Specifications",
    "shortTitle": "Premier Nop Carpet Tile",
    "category": "Carpet Tile",
    "industries": [
      "Retail",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_PremierNop.pdf"
  },
  {
    "id": "techspec-premier-nop---customs",
    "title": "Premier Nop Custom Logo Mat - Technical Specifications",
    "shortTitle": "Premier Nop Custom Logo Mat",
    "category": "Custom Logo Mats",
    "industries": [
      "Retail",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_PremierNop_CLM.pdf"
  },
  {
    "id": "techspec-premier-nop---rg",
    "title": "Premier Nop Roll Goods - Technical Specifications",
    "shortTitle": "Premier Nop Roll Goods",
    "category": "Broadloom",
    "industries": [
      "Retail",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_PremierNop__RG.pdf"
  },
  {
    "id": "techspec-ramp-5207",
    "title": "Ramp 5207 - Technical Specifications",
    "shortTitle": "Ramp 5207",
    "category": "Accessories",
    "industries": [
      "All Industries"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_FTS_RAMP-5207.pdf"
  },
  {
    "id": "techspec-rlpx-ramp",
    "title": "RLPX Ramp - Technical Specifications",
    "shortTitle": "RLPX Ramp",
    "category": "Accessories",
    "industries": [
      "All Industries"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_FTS_RAMP-RLPX.pdf"
  },
  {
    "id": "techspec-rover-tile",
    "title": "Rover Carpet Tile - Technical Specifications",
    "shortTitle": "Rover Carpet Tile",
    "category": "Carpet Tile",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TSS_Rover.pdf"
  },
  {
    "id": "techspec-s-trax-plus",
    "title": "S-Trax Plus Entry System - Technical Specifications",
    "shortTitle": "S-Trax Plus Entry System",
    "category": "Grid Matting",
    "industries": [
      "Retail",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_STraxPlus.pdf"
  },
  {
    "id": "techspec-safe-tread---customs",
    "title": "Safe Tread Custom Logo Mat - Technical Specifications",
    "shortTitle": "Safe Tread Custom Logo Mat",
    "category": "Custom Logo Mats",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TSS_SafeTread_CLM.pdf"
  },
  {
    "id": "techspec-safeguard-giant-tiles",
    "title": "Safeguard Giant Tiles - Technical Specifications",
    "shortTitle": "Safeguard Giant Tiles",
    "category": "Carpet Tile",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_SafeguardGiant.pdf"
  },
  {
    "id": "techspec-safestep-plus",
    "title": "SafeStep Plus Non-Slip - Technical Specifications",
    "shortTitle": "SafeStep Plus Non-Slip",
    "category": "Non-Slip",
    "industries": [
      "Retail",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_SafeStepPlus.pdf"
  },
  {
    "id": "techspec-senator-softstep-plus",
    "title": "Senator SoftStep Plus Carpet Tile - Technical Specifications",
    "shortTitle": "Senator SoftStep Plus Carpet Tile",
    "category": "Carpet Tile",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TSS_SenatorSoftStepPlus.pdf"
  },
  {
    "id": "techspec-smf-17",
    "title": "SMF-17 Adhesive - Technical Specifications",
    "shortTitle": "SMF-17 Adhesive",
    "category": "Accessories",
    "industries": [
      "All Industries"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_FTS_SMF-17.pdf"
  },
  {
    "id": "techspec-snap-trax-plus",
    "title": "Snap Trax Plus Entry System - Technical Specifications",
    "shortTitle": "Snap Trax Plus Entry System",
    "category": "Grid Matting",
    "industries": [
      "Retail",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_SnapTraxPlus.pdf"
  },
  {
    "id": "techspec-snap-trax-tile",
    "title": "Snap Trax Tile - Technical Specifications",
    "shortTitle": "Snap Trax Tile",
    "category": "Grid Matting",
    "industries": [
      "Retail",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_SnapTraxTile.pdf"
  },
  {
    "id": "techspec-spectra-print-h-d",
    "title": "Spectra Print H.D Custom Logo Mat - Technical Specifications",
    "shortTitle": "Spectra Print H.D Custom Logo Mat",
    "category": "Custom Logo Mats",
    "industries": [
      "Retail",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TSS_SpectraPrint-HD.pdf"
  },
  {
    "id": "techspec-superior-nop",
    "title": "Superior Nop Roll Goods - Technical Specifications",
    "shortTitle": "Superior Nop Roll Goods",
    "category": "Broadloom",
    "industries": [
      "Hospitality",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_SuperiorNop_RG.pdf"
  },
  {
    "id": "techspec-supertac-matting",
    "title": "SuperTac Matting - Technical Specifications",
    "shortTitle": "SuperTac Matting",
    "category": "Commercial Mats",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_SuperTac.pdf"
  },
  {
    "id": "techspec-synthetic-coco---custom",
    "title": "Synthetic Coco Custom Logo Mat - Technical Specifications",
    "shortTitle": "Synthetic Coco Custom Logo Mat",
    "category": "Custom Logo Mats",
    "industries": [
      "Hospitality",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_SynCoco_CLM.pdf"
  },
  {
    "id": "techspec-synthetic-coco---rg",
    "title": "Synthetic Coco Roll Goods - Technical Specifications",
    "shortTitle": "Synthetic Coco Roll Goods",
    "category": "Broadloom",
    "industries": [
      "Hospitality",
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_SynCoco_RG.pdf"
  },
  {
    "id": "techspec-t-section",
    "title": "T-Section Trim - Technical Specifications",
    "shortTitle": "T-Section Trim",
    "category": "Accessories",
    "industries": [
      "All Industries"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_ACTS_T-Section.pdf"
  },
  {
    "id": "techspec-threshold-001",
    "title": "Threshold 001 - Technical Specifications",
    "shortTitle": "Threshold 001",
    "category": "Accessories",
    "industries": [
      "All Industries"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_FTS_Threshold-001.pdf"
  },
  {
    "id": "techspec-tidal---tidal-diamond",
    "title": "Tidal & Tidal Diamond Commercial Mats - Technical Specifications",
    "shortTitle": "Tidal & Tidal Diamond Commercial Mats",
    "category": "Commercial Mats",
    "industries": [
      "Commercial"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_TechSpecs_Tidal.pdf"
  },
  {
    "id": "techspec-tlp-section",
    "title": "TLP-Section Trim - Technical Specifications",
    "shortTitle": "TLP-Section Trim",
    "category": "Accessories",
    "industries": [
      "All Industries"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_ACTS_TLP-Section.pdf"
  },
  {
    "id": "techspec-u-section",
    "title": "U-Section Trim - Technical Specifications",
    "shortTitle": "U-Section Trim",
    "category": "Accessories",
    "industries": [
      "All Industries"
    ],
    "pdf": "/Assets/pdf/tech-specs/PS_ACTS_U-Section.pdf"
  }
];
